// extracted by mini-css-extract-plugin
export default {"notification-list":"app-notifications_notification-list__tEoCz","animated":"app-notifications_animated__zAW4u","hidden":"app-notifications_hidden__w1Dmt"};